import { Box, Typography, useTheme } from "@mui/material";
import { FC, useContext } from "react";
import { StyledButton } from "../../StyledButton";
import { AuthenticatedUserContext } from "@ngt/forms";


const LogoutButton: FC = () => {
    const theme = useTheme();
    const user = useContext(AuthenticatedUserContext);

    return (
        <Box
            sx={{
                display: "flex",
                gap: theme.spacing(2),
                alignItems: "center",
                marginRight: theme.spacing(2)
            }}
        >
            <Typography
                sx={{
                    color: theme.palette.primary.light
                }}
            >
                {user.data?.displayName}
            </Typography>

            <StyledButton
                href="/auth/logout"
            >
                Logout
            </StyledButton>
        </Box>
    );
}

export default LogoutButton;